import { render, staticRenderFns } from "./NotificationsSlideout.vue?vue&type=template&id=6bf9b632"
import script from "./NotificationsSlideout.vue?vue&type=script&lang=js"
export * from "./NotificationsSlideout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports